import {
    GridCallbackDetails,
    GridColDef,
    GridPaginationModel,
    GridRowParams,
    GridSortModel,
} from '@mui/x-data-grid';

import { DataGrid, DataGridCard } from '@barboxx/admin-components';
import { useBusinessSelector } from '@barboxx/admin-utils';
import { Category } from '@barboxx/models';

type Columns = GridColDef<Category>[];

const COLUMNS: Columns = [
    { field: 'id', headerName: 'Id', width: 70 },
    { field: 'name', headerName: 'Name', width: 200 },
    { field: 'description', headerName: 'Description', width: 200, flex: 1 },
    {
        field: 'categoryType',
        headerName: 'Category Type',
        type: 'singleSelect',
        width: 120,
    },
];

interface Props {
    data: Category[];
    size: number;
    page: number;
    total: number;
    onRowClick: (id: string) => void;
    onChangeSort: (sort: GridSortModel) => void;
    handleChangePageModel: (
        model: GridPaginationModel,
        details: GridCallbackDetails
    ) => void;
}

export function CategoryTable(props: Props) {
    const {
        data = [],
        total,
        size,
        page,
        onRowClick,
        handleChangePageModel,
        onChangeSort,
    } = props;

    const { businessList } = useBusinessSelector();

    const handleRowClick = (param: GridRowParams) => {
        onRowClick(param.id as string);
    };

    const columns: Columns = COLUMNS.concat({
        field: 'businessId',
        headerName: 'Business',
        type: 'singleSelect',
        width: 120,
        valueOptions: businessList.map(b => ({
            label: b.place.name,
            value: b.id,
        })),
    });

    return (
        <DataGridCard title="Categories">
            <DataGrid
                rows={data}
                columns={columns}
                paginationModel={{
                    page,
                    pageSize: size,
                }}
                onPaginationModelChange={handleChangePageModel}
                rowCount={total}
                disableColumnMenu
                onRowClick={handleRowClick}
                onSortModelChange={onChangeSort}
            />
        </DataGridCard>
    );
}
